<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { ScrollAreaCorner, ScrollAreaRoot, ScrollAreaViewport } from 'reka-ui';

import ScrollBar from '@/components/lib/shadcn-vue/scroll-area/ScrollBar.vue';
import { cn } from '@/components/lib/shadcn-vue/utils';

import type { ScrollAreaRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<ScrollAreaRootProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <ScrollAreaRoot v-bind="delegatedProps" :class="cn('relative flex flex-col overflow-hidden', props.class)">
    <ScrollAreaViewport class="min-h-0 w-full flex-1 rounded-[inherit]">
      <slot />
    </ScrollAreaViewport>
    <ScrollBar />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
